import {cardImages} from './../assets/ImageIndex'

import {card_18_01_25} from './CardsData/card_18_01_25'
import {card_19_01_25} from './CardsData/card_19_01_25'
import {card_17_01_25} from './CardsData/card_17_01_25'
import {card_16_01_25} from './CardsData/card_16_01_25'
import {card_15_01_25} from './CardsData/card_15_01_25'
import {card_14_01_25} from './CardsData/card_14_01_25'
import {card_13_01_25 } from './CardsData/card_13_01_25'
import {card_20_01_25} from './CardsData/card_20_01_25'
import {card_21_01_25} from './CardsData/card_21_01_25'
import {card_24_01_25} from './CardsData/card_24_01_25'
import {card_13_02_25} from './CardsData/card_13_02_25'


export const blogCardData = [
  //card_21_01_25,
  //card_13_01_25,
  //card_19_01_25,
  //card_18_01_25,
  card_17_01_25,
  card_16_01_25,
  card_15_01_25,
  card_14_01_25,
  card_18_01_25,
  //card_20_01_25,
  card_24_01_25,
  card_13_02_25,
].sort((a, b) => {
  // Converte as datas para objetos Date para comparação
  const parseDate = (dateString: string): Date => {
    const [day, month, year] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day); // `month - 1` porque os meses no JS são baseados em zero
  };

  // Converte as datas para objetos `Date`
  const dateA = parseDate(a.date);
  const dateB = parseDate(b.date);

  // Ordem decrescente (mais recente primeiro)
  return dateB.getTime() - dateA.getTime();
});

/*
export const blogCardData = [
  card_13_01_25,
  card_19_01_25,
  card_18_01_25,
  card_17_01_25,
  card_16_01_25,
  card_15_01_25,
  card_14_01_25,

*/